import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { FileUploader, FileItem, ParsedResponseHeaders } from "ng2-file-upload";
import { env } from "@env/environment";
import { ResponseUploadFileVO } from "@app/shared/vo/response-upload-fileVO";
import { Subscription } from "rxjs";
import { ControlContainer, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { FormFileCaricatoVO } from "@app/shared/vo/form-file-caricatoVO";
import { NotifierService } from "angular-notifier";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { ISubscription } from "rxjs-compat/Subscription";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { DocumentoVO } from "@app/shared/vo/documentoVO";
import { ProtocolloService } from "@app/shared/services/protocollo.service";

@Component({
  selector: "app-upload-multi-file",
  templateUrl: "./upload-multi-file.component.html",
})
export class UploadMultiFileComponent implements OnInit, OnDestroy {
  idRepository: string;
  hash: string;
  nome: string;
  allegatiFormArray: FormArray;
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  public uploader: FileUploader;
  private urlUpload = env.API_UPLOAD_BASE + env.URL_UPLOAD;
  loadingIndicator: boolean;
  public progresso: number = 0;
  listaMimeTypeConsentiti: string[];
  lettereAlfabeto: string = "ABCDEFGHILMNOPQRSTUVZ";

  // documentoCaricato: DocumentoVO = new DocumentoVO();
  subscriptions: Subscription[] = [];
  messages = {
    emptyMessage: "Nessun Allegato",
    totalMessage: "in totale",
  };
  nomeFile: string;
  caricamentoEseguito: boolean = false;
  private accessToken: string;

  private utenteSubscription: Subscription;

  constructor(
    private controlContainer: ControlContainer,
    private notifierService: NotifierService,
    private autenticazioneService: AutenticazioneService,
    private protocolloService: ProtocolloService
  ) {
  }

  inizializzaUploader() {
    this.progresso = 0;

    this.listaMimeTypeConsentiti = [
      "application/pdf",
      "image/jpeg",
      "application/pkcs7",
      "application/pkcs7-mime",
    ];
    this.uploader = new FileUploader({
      url: this.urlUpload,
      autoUpload: true,
      authToken: "Bearer " + this.accessToken,
      allowedMimeType: this.listaMimeTypeConsentiti,
    });
    this.uploader.onWhenAddingFileFailed = (
      item: any,
      filter: any,
      options: any
    ) => {
      console.log(
        "[ModaleAggiungiUd.constructor] onAfterAddingAll, item:",
        item
      );
      if (!this.listaMimeTypeConsentiti.includes(item.type)) {
        this.notifierService.notify(
          "warning",
          "Impossibile caricare il documento, formato non consentito"
        );
      }
      this.loadingIndicator = true;
      this.messages.emptyMessage = "Upload allegato....";
    };
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onErrorItem = (
      item: FileItem,
      response: string,
      status: number,
      headers: ParsedResponseHeaders
    ): any => {
      console.log("[ModaleAggiungiUd.constructor] response ", response);
      console.log("[ModaleAggiungiUd.constructor] item ", item);
      console.log("[ModaleAggiungiUd.constructor] status ", status);
      console.log("[ModaleAggiungiUd.constructor] headers ", headers);

      this.loadingIndicator = false;

      this.notifierService.notify(
        "warning",
        "Impossibile caricare il documento!"
      );

      this.caricamentoEseguito = true;
      this.progresso = 0;
    };

    this.uploader.onSuccessItem = (item: any, response: any) => {
      console.log("ModaleAggiungiUd.constructor] onSuccessItem: ", item.type);
      const res: ResponseUploadFileVO = <ResponseUploadFileVO>(
        JSON.parse(response)
      );
      this.idRepository = res.id;
      this.caricamentoEseguito = true;
      this.progresso = 0;
      this.nomeFile = item.file.name;
      // Controllo del mimetype reale del file caricato lato server
      this.protocolloService.controllaMimetype(res.id).subscribe((mimetype: string) => {
        if (!this.listaMimeTypeConsentiti.includes(mimetype)) {
          this.notifierService.notify(
            "warning",
            "Impossibile caricare il documento, formato non consentito"
          );
          return;
        }
        const length = this.allegatiFormArray.controls.length;
        let allegati: DocumentoVO[] = this.allegatiFormArray.value;
        let numeroAllegatiPadre: number = allegati.filter(res => res.idAllegatoPadre == null).length;
        console.log("[crea-atto][aggiungi ]lenght: ", length);
        if (this.allegatiFormArray.value.findIndex(res => res.idRepository == this.idRepository) != -1) {
          this.notifierService.notify("warning", "Documento già inserito!");
          return;
        }
        this.allegatiFormArray.insert(
          length,
          new FormGroup({
            hash: new FormControl(res.hash, Validators.required),
            nome: new FormControl(this.nomeFile, Validators.required),
            idRepository: new FormControl(this.idRepository, Validators.required),
            pubblicabile: new FormControl(true, Validators.required),
            contieneDatiPersonali: new FormControl(false),
            codice: new FormControl(this.lettereAlfabeto.charAt(numeroAllegatiPadre))
          })
        );
        console.log("aggiungi", this.allegatiFormArray.controls);
      });
    };

    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      console.log(
        "[modale-versioni-documento][onProgressItem] " +
        fileItem +
        ", progresso: " +
        progress
      );
      this.progresso = fileItem.progress;
    };
  }

  ngOnInit() {
    this.utenteSubscription = this.autenticazioneService.utenteAnnounced$
      .subscribe(utente => {
        console.log("[upload-multi-file][utente subscription] nuovo token utente: " + utente.token);
        this.accessToken = utente.token;
        this.inizializzaUploader();
      });
    this.allegatiFormArray = this.controlContainer.control.get("allegati") as FormArray;
    if (this.nome) {
      console.log("this.nome", this.nome);
      this.nomeFile = this.nome;
    }
  }


  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }



  public ricevoDocumento(doc: FormFileCaricatoVO) {
    // this.rimuoviDocumento();
    this.idRepository = doc.idRepository;
    this.caricamentoEseguito = true;
    this.nomeFile = doc.nome;
    // this.uploadFileFormGroup.setValue({
    //   nome: doc.nome,
    //   hash: doc.hash,
    //   documentoDaSistema: false,
    //   controlliPrimarioAllegati: "",
    //   controlliNomePrimarioAllegati: "",
    //   controlliAllegati: "",
    //   idRepository: doc.idRepository,
    //   dataInserimento: null,
    //   dimensioni: null,
    //   bozza: false,
    // });
  }



  rimuovi(i: number) {
    console.log("<>>>> ", this.allegatiFormArray);
    this.allegatiFormArray.removeAt(i);
  }


  ngOnDestroy(): void {
    if (this.utenteSubscription) {
      this.utenteSubscription.unsubscribe();
    }
  }
}
